import React from 'react';
import PropTypes from 'prop-types';

import TabStyled from './TabStyled';

class Tab extends React.PureComponent {
  handleTabClick = () => {
    this.props.onChange(this.props.tab);
  }

  render() {
    return (
      <TabStyled
        key={this.props.tab.label}
        style={this.props.style}
        active={this.props.active}
        onClick={this.handleTabClick}
      >
        {this.props.tab.label}
      </TabStyled>
    );
  }
}

Tab.propTypes = {
  tab: PropTypes.shape({ label: PropTypes.string }).isRequired,

  style: PropTypes.shape({}),
  active: PropTypes.bool,
  onChange: PropTypes.func,
};

Tab.defaultProps = {
  style: undefined,
  active: false,
  onChange: () => {},
};

export default Tab;
